import { createSlice } from '@reduxjs/toolkit';
import {
    ACCESS_TOKEN_STATUS,
    SHARE_BINDING_STATUS,
    SHARE_STATE,
    SOCIAL_KEY,
} from '@src/constants/FJShareSocialConstant.ts';

const _getTargetData = (type: string) => {
    return window?.fjuser?.info?.account_link?.[type];
};

const _initialShareData = (type: (typeof SOCIAL_KEY)[keyof typeof SOCIAL_KEY]) => {
    return {
        linkAccountState: _getTargetData(type)?.isLink ? SHARE_BINDING_STATUS.LINKED : SHARE_BINDING_STATUS.UN_LINK, // LINKING | UN_LINK | LINKED
        accessTokenState: _getTargetData(type)?.access_token ? ACCESS_TOKEN_STATUS.VALID : ACCESS_TOKEN_STATUS.INVALID, // accessToken的状态 INVALID | VALID | WAIT_CHECK
        shareState: SHARE_STATE.SHARE_IDLE, // SHARE_IDLE | SHARING | SHARE_SUCCESS | SHARE_FAIL | WAIT_SHARE *(待输出完成后执行分享)
        shareType: type,
        email: _getTargetData(type)?.email ?? '',
        name: _getTargetData(type)?.user_name ?? '',
        avatar: '',
    };
};

const FJShareSlice = createSlice({
    name: 'FJShareSlice',
    initialState: {
        isShow: false,
        googleDrive: _initialShareData(SOCIAL_KEY.GOOGLE_DRIVE),
        instagram: _initialShareData(SOCIAL_KEY.INSTAGRAM),
        youtube: _initialShareData(SOCIAL_KEY.YOUTUBE),
        linkedin: _initialShareData(SOCIAL_KEY.LINKEDIN),
        // tiktok: _initialShareData(SOCIAL_KEY.TIKTOK),
        selectedShareTypes: [],
        publishedTypes: [],
        failedTypes: [],
        isShowAddAccountPanel: false,
        linkedinError: '',
    },
    reducers: {
        setIsShow(state, action) {
            state.isShow = action.payload;
        },
        updateShareState(state, action) {
            const { shareType, data } = action.payload;
            state[shareType] = { ...state[shareType], ...data };
        },
        setIsShowAddAccountPanel(state, action) {
            state.isShowAddAccountPanel = action.payload;
        },
        setSelectedShareTypes(state, action) {
            state.selectedShareTypes = action.payload;
        },
        setPublishedTypes(state, action) {
            state.publishedTypes = action.payload;
        },
        setFailedTypes(state, action) {
            state.failedTypes = action.payload;
        },
        setLinkedinError(state, action) {
            state.linkedinError = action.payload;
        },
    },
});

export default FJShareSlice;
